import { default as MuiListItemIcon } from '@mui/material/ListItemIcon';

/**
 * ListItemIcon displays an icon within a ListItem.
 *
 * Demos:
 *
 * - [List Item Icon](https://unify.workiva.org/components/list?tab=code#adornments)
 *
 * API:
 *
 * - [ListItemIcon API](https://unify.workiva.org/components/list?tab=props#listitemicon)
 */
export const ListItemIcon = MuiListItemIcon;
export {
  type ListItemIconProps,
  listItemIconClasses,
} from '@mui/material/ListItemIcon';
